import React, {useEffect} from 'react';
import {useGenerateShapeElementsMutation} from "../services/productApi";
import {useDispatch, useSelector} from "react-redux";
import {displayGeneratedShapeElements} from "../../store/product/productSelectionsSlice";
import {setErrors, setShapeRequestPending} from "../../store/configuratorStateSlice";
import {summaryLoaded, summaryLoading} from "../../store/summarySlice";



const GenerateShapeElementsButton = (props) => {
    const productId = useSelector( state => state.productDataReducer.id);
    const shapedAttributes = useSelector(state => state.productSelectionsReducer.shapedAttributes);
    const attributeSelections = useSelector(state => state.productDataReducer.attribute_selections);
    const shapeRequestPending = useSelector(state => state.configuratorStateReducer.shapeRequestPending)
    const dispatch = useDispatch()
    const [
        generateShapeElements,
        {
            isLoading: isUpdating,
            isSuccess: generateShapeElementsSuccess,
            isError: generateShapeElementsError,
            data : generatedShapeElements
        },
    ] = useGenerateShapeElementsMutation();

    // display shapes when request succeeds
    useEffect(() => {
        if(generateShapeElementsSuccess) {
            dispatch(displayGeneratedShapeElements(generatedShapeElements.generated_shape_elements));
        }
    }, [generateShapeElementsSuccess])

    useEffect(() => {
        if(generateShapeElementsError) {
            dispatch(setShapeRequestPending(false))
            dispatch(summaryLoaded())
            dispatch(setErrors(['Error Generating Element Shapes']));
            dispatch({type: 'ADD_NOTICE', notice_type: 'catalog_number', message: "Error Generating Element Shapes"})

        }
    }, [generateShapeElementsError])

    if(shapedAttributes.length === 0) {
        return null
    }

    const handleClick = (e) => {
        if(!shapeRequestPending) {
            dispatch(setErrors([]));
            dispatch({type: 'CLEAR_NOTICES'})
            dispatch(setShapeRequestPending(true))
            dispatch(summaryLoading());
            generateShapeElements({
                id: productId,
                attribute_selections: attributeSelections
            })
        }
    }

    return (
        <div onClick={() => handleClick()} className={'button ' + (shapeRequestPending ? 'disabled' : '')}
                 style={{margin: '25px 15px'}}>Generate Elements</div>
    )

}

export default GenerateShapeElementsButton;
